import React, { Fragment } from "react";
import { PropTypes } from "prop-types";
import classNames from "classnames";
import Fade from "@material-ui/core/Fade";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { HeaderMenu, BreadCrumb } from "components";
import Decoration from "../Decoration";
import styles from "../appStyles-jss";

class DropMenuLayout extends React.Component {
  render() {
    const {
      classes,
      children,
      pageLoaded,
      mode,
      gradient,
      deco,
      history,
      bgPosition,
      changeMode,
      place,
      titleException,
      handleOpenGuide,
      toggleDrawer,
      sidebarOpen,
      loadTransition,
      user,
      dataMenu
    } = this.props;
    return (
      <>
        <HeaderMenu
          type="mega-menu"
          dataMenu={dataMenu}
          changeMode={changeMode}
          mode={mode}
          history={history}
          openGuide={handleOpenGuide}
          toggleDrawerOpen={toggleDrawer}
          openMobileNav={sidebarOpen}
          loadTransition={loadTransition}
          logoLink="/"
          user={user}
        />
        <main
          className={
            classNames(
              classes.content,
              classes.highMargin
            )
          }
          id="mainContent"
        >
          <Decoration
            mode={mode}
            gradient={gradient}
            decoration={deco}
            bgPosition={bgPosition}
            horizontalMenu
          />
          <section className={classNames(classes.mainWrap, classes.topbarLayout)}>
            {!titleException.find(regex => regex.test(history.location.pathname)) && (
              <div className={classes.pageTitle}>
                <Typography component="h4" className={bgPosition === "header" ? classes.darkTitle : classes.lightTitle} variant="h4">{place}</Typography>
                <BreadCrumb separator=" / " theme={bgPosition === "header" ? "dark" : "light"} location={history.location} />
              </div>
            )}
            { !pageLoaded && (<img src="./images/spinner.gif" alt="spinner" className={classes.circularProgress} />) }
            <Fade
              in={pageLoaded}
              mountOnEnter
              unmountOnExit
              {...(pageLoaded ? { timeout: 700 } : {})}
            >
              <div className={!pageLoaded ? classes.hideApp : ""}>
                {/* Application content will load here */}
                { children }
              </div>
            </Fade>
          </section>
        </main>
      </>
    );
  }
}

DropMenuLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  history: PropTypes.object.isRequired,
  changeMode: PropTypes.func.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  loadTransition: PropTypes.func.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
  pageLoaded: PropTypes.bool.isRequired,
  mode: PropTypes.string.isRequired,
  gradient: PropTypes.bool.isRequired,
  deco: PropTypes.bool.isRequired,
  bgPosition: PropTypes.string.isRequired,
  place: PropTypes.string.isRequired,
  titleException: PropTypes.array,
  handleOpenGuide: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  dataMenu: PropTypes.array.isRequired
};

DropMenuLayout.defaultProps = {
  titleException: [/^\/?$/]
};

export default (withStyles(styles)(DropMenuLayout));
